import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79a56a2d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex gap-3 flex-column" }
const _hoisted_2 = { class: "col-12 d-flex justify-content-between align-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "m-0 titulo cor_texto_1"
}
const _hoisted_4 = {
  key: 1,
  class: "m-0 titulo cor_texto_1"
}
const _hoisted_5 = { class: "d-flex gap-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-arrow-left" }, null, -1))
const _hoisted_7 = {
  key: 0,
  width: "20",
  height: "20",
  fill: "white",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 416c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  style: {"color":"#fefefe"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "p-3" }
const _hoisted_14 = { class: "row gap-5" }
const _hoisted_15 = {
  class: "card mb-5 col-sm",
  label: "Dados Loja"
}
const _hoisted_16 = {
  class: "card mb-5 col-sm",
  label: "Marca Parceiras"
}
const _hoisted_17 = { label: "Config. Loja" }
const _hoisted_18 = { class: "row flex-row gap-5" }
const _hoisted_19 = {
  class: "card mb-5 col-sm",
  label: "Implantação"
}
const _hoisted_20 = {
  class: "card mb-5 col-sm",
  label: "Integração"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_dados_da_loja = _resolveComponent("dados-da-loja")!
  const _component_marca_padrao = _resolveComponent("marca-padrao")!
  const _component_config_lojas = _resolveComponent("config-lojas")!
  const _component_dados_da_implantacao = _resolveComponent("dados-da-implantacao")!
  const _component_dados_extras_ipiranga = _resolveComponent("dados-extras-ipiranga")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      (_ctx.nomeLojaDinamico)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Editando " + _toDisplayString(_ctx.nomeLojaDinamico), 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_4, "Criando loja")),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Button, {
          type: "button",
          text: "Voltar",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleScreenEdit'), _ctx.getUseOpenCreateStore.close(), _ctx.getIntegracaoParceirosStore.clear()))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          type: "button",
          variant: "secondary",
          text: "Salvar",
          onClick: _ctx.sendUpdateInfos
        }, {
          default: _withCtx(() => [
            (!_ctx.loadingSalvar)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_9))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_dados_da_loja)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_marca_padrao)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_config_lojas, { dadosNovaLoja: _ctx.dadosParaNovaLoja }, null, 8, ["dadosNovaLoja"])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_dados_da_implantacao)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_dados_extras_ipiranga)
        ])
      ])
    ])
  ]))
}